import { render, staticRenderFns } from "./modalRetificacaoLaudo.vue?vue&type=template&id=1b40d7b4&"
import script from "./modalRetificacaoLaudo.vue?vue&type=script&lang=js&"
export * from "./modalRetificacaoLaudo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports